import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { GET } from "../../utils/HttpClient";
import { URL_POST_BAKING } from "../../constance/urls";
import ErrorMessage from "../common/ErrorMessage";
import Title from "antd/es/typography/Title";
import { Space, Spin, Button, Form, Radio, List } from "antd";
import ColorButton from "../common/ColorButton";
import { BLUE_COLOR } from "../../constance/color";
import { FileTextOutlined } from "@ant-design/icons";


export default function SelectOvenSetDetail(props) {
  const {
    groupDate,
    onGoToOvenSetDetail,
    onBack,
  } = props;

  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [ovenSetList, setOvenSetList] = React.useState([]);
  const selectedOvenSet = Form.useWatch('ovenSet', form);

  const handleCountWood = () => {
    setErrorMessages(null);
    if (!selectedOvenSet || !selectedOvenSet.length) {
      setErrorMessages(t('post_baking_waste_wood_count.errors.select_oven'))
      return;
    }
    onGoToOvenSetDetail(selectedOvenSet)
  }

  const fetchOvenSet = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(URL_POST_BAKING.OVEN_SET, { date: groupDate })
      setOvenSetList(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    if (groupDate) {
      fetchOvenSet()
    }
  }, [groupDate])

  return (
    <div style={{ marginTop: '3rem' }}>
      <Title level={5}>{t('post_baking_waste_wood_count.oven_set_wood_status')}</Title>
      <ErrorMessage message={errorMessages} />
      <Spin spinning={loading} tip={t('loading')} fullscreen />
      <Form form={form} onFinish={handleCountWood}>
        <Form.Item name={'ovenSet'}>
          <Radio.Group>
            <List>
              {ovenSetList.map(ovenSet => (
                <List.Item>
                  <Radio value={ovenSet}>{ovenSet.join(', ')}</Radio>
                </List.Item>
              ))}
            </List>
          </Radio.Group>
        </Form.Item>

        <Space >
          <ColorButton
            type='primary' override={BLUE_COLOR} icon={<FileTextOutlined />} htmlType='submit'>{t('detail')}</ColorButton>
          <Button variant="filled" color="default" onClick={onBack} >{t('back')}</Button>
        </Space>

      </Form>
    </div>
  )
}


SelectOvenSetDetail.propTypes = {
  groupDate: PropTypes.string,
  onGoToOvenSetDetail: PropTypes.func,
  onBack: PropTypes.func,
}

SelectOvenSetDetail.defaultProps = {
  groupDate: null,
  onGoToOvenSetDetail: () => null,
  onBack: () => null,
}